import styled from '@emotion/styled';
import rem from '../../../../utils/rem/rem';

export const TableWrapper = styled.div`
width: calc(60vw - 232px);
min-width: ${rem(396)};

@media ${({ theme }) => theme.breakpoints.lg} {
  width: 100%;
}
`;

export const SelectMenusPage = styled.div`
padding: 0 32px;
`;

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  margin-bottom: ${rem(16)};
  gap: ${rem(16)} 32px;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;



export const Buttons = styled.div`
display: flex;
  justify-content: space-between;
  padding-top: ${rem(16)};
`;
